import { Box, FormControl, Stack, Text } from '@chakra-ui/react';

import { Button, FormLabel } from '@/components/v4';
import {
    descriptionStyling,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

function UserPlatformConvertRa({ onOpen, darkMode, walkthroughIds }) {
    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                sx={{
                    ...stackStyling(true),
                    width: '740px',
                }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Convert RA to User
                    </FormLabel>

                    <Text sx={descriptionStyling} maxWidth={250}>
                        This action will convert a resource account to a user
                        account
                    </Text>
                </Box>
                <Box
                    display="flex"
                    width={488}
                    alignItems="center"
                    justifyContent="flex-end"
                    marginTop={10}>
                    <Button
                        maxW="142px"
                        colorScheme="red"
                        onClick={onOpen}
                        data-walkthroughid={walkthroughIds.admin.ufConvertBtn}>
                        Convert
                    </Button>
                </Box>
            </Stack>
        </FormControl>
    );
}
export default UserPlatformConvertRa;
